const MedicalScience = () => {
    return (
        <>
            <div className="about-ed-wrapper-impact">
                <h2 className="about-ed-heading-impact">Medical Science</h2>
                <div className="about-ed-block-impact">
                    <div className="about-ed-content-impact">
                        <ul className="journal-ul-impact">
                            <li className="journal-li-impact">General Medicine</li>
                            <li className="journal-li-impact">Public health & hygiene</li>
                            <li className="journal-li-impact">Tropical diseases</li>
                            <li className="journal-li-impact">Endocrinology</li>
                            <li className="journal-li-impact">Anatomy</li>
                            <li className="journal-li-impact">Neurology</li>
                            <li className="journal-li-impact">Dermatology</li>
                            <li className="journal-li-impact">Orthopedics</li>
                            <li className="journal-li-impact">Organ transplantation</li>
                            <li className="journal-li-impact">Oncology</li>
                            <li className="journal-li-impact">Pathology</li>
                            <li className="journal-li-impact">Hematology</li>
                            <li className="journal-li-impact">Nephrology</li>
                            <li className="journal-li-impact">Gynecology</li>
                            <li className="journal-li-impact">Ophthalmology</li>
                            <li className="journal-li-impact">Pediatrics</li>
                            <li className="journal-li-impact">Radiology</li>
                            <li className="journal-li-impact">Medical Biotechnology</li>
                            <li className="journal-li-impact">Dentistry</li>
                            <li className="journal-li-impact">Nursing</li>
                            <li className="journal-li-impact">Cardiology</li>
                            <li className="journal-li-impact">Respiratory Medicine</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MedicalScience;
